import { render, staticRenderFns } from "./cloudrec.vue?vue&type=template&id=7e0543c1&"
import script from "./cloudrec.vue?vue&type=script&lang=js&"
export * from "./cloudrec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports